import { Container } from "inversify"

const container = new Container()

export default container
